// Dependencies
import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import * as $ from 'jquery';

@Component({
    selector: 'survey-gizmo-page',
    templateUrl: './survey-gizmo-page.component.html',
    styleUrls: ['./survey-gizmo-page.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SurveyGizmoPageComponent {
    constructor(private activatedRoute: ActivatedRoute, private router: Router) {}


    //----------------------------------
    // Properties
    //----------------------------------

    @ViewChild('iframe') iframeEl: ElementRef;

    surveyUrl: string = null;


    //----------------------------------
    // Methods
    //----------------------------------

    ngOnInit() {
        const paramObservable = Observable.combineLatest(
            this.activatedRoute.params,
            this.activatedRoute.queryParams,
            (routeParams, queryParams) => ({ routeParams, queryParams })
        );

        paramObservable.subscribe(paramObject => {
            let url = paramObject.queryParams.url;
            let queryString = '';

            console.log(paramObject.queryParams);

            // Add any parameters that are keyed with an 'organizations_' prefix
            for (var key in paramObject.queryParams) {
                if(key.startsWith('organizations_', 0)) { // we could also only allow `id,name,role,meta_`
                    queryString += `&${key}=${paramObject.queryParams[key]}`;
                }
            }
            queryString += `&study_revision=${paramObject.queryParams.study_revision}`;
            queryString += (paramObject.queryParams.sglocale) ? `&sglocale=${paramObject.queryParams.sglocale}` : '';

            this.surveyUrl = url + '?' + queryString;
        });
    }

    resizeIframe() {
        this.iframeEl.nativeElement.style.height = $(window).height() + 'px';
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/study-container-page/survey-gizmo-page/survey-gizmo-page.component.ts